<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row
              class="pa-4 pb-0 pr-1">
              <v-col
                cols="12">
                <v-card
                  to="/product"
                  flat
                  color="transparent"
                  style="width: 20%;">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="20"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="16"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
  
                    <span
                      class="fs-16 black--text ml-3"
                      style="font-weight: 600;">
                      Ubah Fasilitas Umum
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4 pb-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  height="calc(100vh - 220px)"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <v-row>
                          <v-col cols="12" class="py-0">
                            <ValidationProvider
                              name="Nama Fasilitas Umum" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
                                Nama Fasilitas Umum
                              </div>
  
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Nama Fasilitas Umum"
  
                                hide-details
                                autofocus
  
                                v-model="form.name"
                                :success="form.name !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.name !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <!-- <v-col cols="4" class="py-0">
                            <ValidationProvider
                              name="Kapasitas" 
                              rules="required|min_value:1" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
                                Kapasitas Fasilitas Umum
                              </div>
  
                              <v-currency-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Kapasitas"
  
                                hide-details
                                type="number"
  
                                v-model="form.capacity_array"
                                :success="form.capacity_array !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.capacity_array !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col> -->
                          <v-col cols="6" class="py-0">
                            <ValidationProvider
                              name="Nama PIC" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
                                Nama PIC Fasilitas Umum
                              </div>
  
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Nama PIC"
  
                                hide-details
  
                                v-model="form.pic_name"
                                :success="form.pic_name !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.pic_name !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <ValidationProvider
                              name="NO WA PIC" 
                              rules="required|min:10|max:13"
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
                                NO WA PIC Fasilitas Umum
                              </div>
  
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                min="0"
  
                                :color="set_color"
                                placeholder="NO WA PIC"
  
                                hide-details
                                prefix="+62"
  
                                v-model="form.pic_wa_number"
                                :success="form.pic_wa_number !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.pic_wa_number !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" class="pt-0">
                            <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                              Kapasitas Fasilitas Umum
                            </div> 
                            <div class="mr-3 mb-2">
                              <!-- <uploadfile
                                v-model="upload.document" >
                                <div 
                                  slot="activator"
                                  class="cursor-pointer"> -->
                                  <v-btn
                                    color="primary"
                                    elevation="0"
                                    small
                                    @click="form.capacity_array.push({ title: '', value: '' })"
                                    min-height="30"
                                    class="fs-12 white--text text-capitalize d-flex align-center"
                                    style="border-radius: 6px; font-weight: 600;">
                                    <v-icon size="15">mdi-file-document</v-icon>
                                    
                                    <span
                                      class="ml-2 ">
                                      Tambah 
                                    </span>
                                  </v-btn>
                                <!-- </div>
                              </uploadfile> -->
                            </div>
  
                            <div class="">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Aksi
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 350px; min-width: 350px; max-width: 350px;" class="black--text">
                                    Konsep Acara
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    Kapasitas
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.capacity_array" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="form.capacity_array.splice(index, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center;" class="black--text">
                                    <div>
                                      <ValidationProvider
                                        :name="`Nama ${index + 1}`" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                    
                                        <v-text-field
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          filled
                                          rounded
                                          dense
                    
                                          :color="set_color"
                                          placeholder="Contoh. Nama Kapasitas"
                    
                                          hide-details
                    
                                          v-model="item.title"
                                          :success="item.title !== '' && valid"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px; width: 350px; min-width: 350px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                    
                                            <div v-if="item.title !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </div>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    <ValidationProvider 
                                      :name="`Kapasitas ${index + 1}`" 
                                      rules="required" 
                                      v-slot="{ errors, valid }">
                  
                                      <v-currency-field
                                        v-on:keydown.enter.prevent="save()"
                                        
                                        filled
                                        rounded
                                        dense
                  
                                        :color="set_color"
                                        placeholder="Kapasitas"
                  
                                        hide-details
                  
                                        v-model="item.value"
                                        :success="item.value !== '' && valid"
                                        :error-messages="errors"
                                        required
                                        class="mb-0"
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                  
                                          <div v-if="item.value !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div>
                                        </template>
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
                            </div>
  
  
                            <v-card-text
                              v-if="form.capacity_array.length === 0"
                              class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                              <div class="text-center">
                                <div class="mt-3 fs-16">
                                  Belum ada data
                                </div>
                              </div>
                            </v-card-text>
  
                          </v-col> 
                          <v-col cols="12" class="py-0">
                            <ValidationProvider 
                              name="Alamat" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
          
                                Alamat
                              </div>
          
                              <v-textarea
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Alamat"
          
                                hide-details
          
                                v-model="form.address"
                                :success="form.address !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
          
                                  <div v-if="form.address !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <div
                              class="mb-6">
                              <div 
                                class="body-2 mb-2">
                                Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                              </div>
  
                              <label>
                                <gmap-autocomplete
                                  placeholder="ketik alamat"
                                  class="style-auto-map mb-4"
                                  @place_changed="setPlace">
                                </gmap-autocomplete>
                              </label>
  
                              <gmap-map
                                :center="center"
                                :zoom="12"
                                :options="{
                                  zoomControl: true,
                                  mapTypeControl: false,
                                  scaleControl: false,
                                  streetViewControl: false,
                                  rotateControl: false,
                                  fullscreenControl: true,
                                  disableDefaultUi: false
                                }"
                                :clickable="true"
                                @click="updatePlace"
                                style="width: 100%; height: 500px;">
  
                                <gmap-marker
                                  :position="center"
                                  :draggable="true"
                                  @drag="updatePlace"
                                  @click="center=center">
                                </gmap-marker>
                              </gmap-map>
                            </div>
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <ValidationProvider 
                              name="Latitude" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
          
                                Latitude
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                readonly
          
                                :color="set_color"
                                placeholder="Latitude"
          
                                hide-details
          
                                v-model="form.latitude"
                                :success="form.latitude !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
          
                                  <div v-if="form.location !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <ValidationProvider 
                              name="Longitude" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
          
                                Longitude
                              </div>
          
                              <v-text-field
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Longitude"
          
                                hide-details
                                readonly
          
                                v-model="form.longitude"
                                :success="form.longitude !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
          
                                  <div v-if="form.request_number !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <ValidationProvider 
                              name="Desripsi Fasilitas Umum" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2 font_weight_600 fs-13 black_one">
                                <span class="red--text">*</span>
          
                                Desripsi Fasilitas Umum
                              </div>
          
                              <v-textarea
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Desripsi Fasilitas Umum"
          
                                hide-details
          
                                v-model="form.desc"
                                :success="form.desc !== '' && valid"
                                :error-messages="errors"
                                required
                                class="mb-6"
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
          
                                  <div v-if="form.desc !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </v-col>
                          <!-- <v-col cols="12" class="pt-0">
                            <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                              Fasilitas
                            </div> 
                            <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
                              <div class="mr-3">
                                <v-btn
                                  color="#4B4B4B"
                                  elevation="0"
                                  small
                                  @click="form.fasilitas.push({ title: '' })"
                                  min-height="30"
                                  class="fs-12 white--text text-capitalize d-flex align-center"
                                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                  <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                  
                                  <span
                                    class="ml-2 ">
                                    Tambah
                                  </span>
                                </v-btn>
                              </div>
                            </div>
  
                            <div class="">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Aksi
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;" class="black--text">
                                    Nama Fasilitas
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.fasilitas" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="form.fasilitas.splice(index, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    <ValidationProvider 
                                      :name="`Nama Fasilitas ${index + 1}`" 
                                      rules="required" 
                                      v-slot="{ errors, valid }">
                  
                                      <v-text-field
                                        v-on:keydown.enter.prevent="save()"
                                        
                                        filled
                                        rounded
                                        dense
                  
                                        :color="set_color"
                                        placeholder="Nama Fasilitas"
                  
                                        hide-details
                  
                                        v-model="item.title"
                                        :success="item.title !== '' && valid"
                                        :error-messages="errors"
                                        required
                                        class="mb-0"
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                  
                                          <div v-if="item.title !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div>
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
                            </div>
  
  
                            <v-card-text
                              v-if="form.fasilitas.length === 0"
                              class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                              <div class="text-center">
                                <div class="mt-3 fs-16">
                                  Belum ada data
                                </div>
                              </div>
                            </v-card-text>
  
                          </v-col>  -->
                          <v-col cols="12" class="pt-0">
                            <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                              Foto & Video
                            </div> 
                            <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
                              <div class="mr-3">
                                <uploadimage
                                  v-model="upload.image" >
                                  <div 
                                    slot="activator"
                                    class="cursor-pointer">
                                    <v-btn
                                      color="#4B4B4B"
                                      elevation="0"
                                      small
                                      :disabled="process.image"
                                      :loading="process.image"
                                      min-height="30"
                                      class="fs-12 white--text text-capitalize d-flex align-center"
                                      style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                      <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                      
                                      <span
                                        class="ml-2 ">
                                        Tambah Gambar
                                      </span>
                                    </v-btn>
                                  </div>
                                </uploadimage>
                              </div>
                              <div class="mr-3">
                                <!-- <uploadfile
                                  v-model="upload.document" >
                                  <div 
                                    slot="activator"
                                    class="cursor-pointer"> -->
                                    <v-btn
                                      color="primary"
                                      elevation="0"
                                      small
                                      @click="form.media_array.push({ title: '', url: '', type: 'video', img_url: '' })"
                                      min-height="30"
                                      class="fs-12 white--text text-capitalize d-flex align-center"
                                      style="border-radius: 6px; font-weight: 600;">
                                      <v-icon size="15">mdi-file-document</v-icon>
                                      
                                      <span
                                        class="ml-2 ">
                                        Tambah Video
                                      </span>
                                    </v-btn>
                                  <!-- </div>
                                </uploadfile> -->
                              </div>
                            </div>
  
                            <div class="">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Aksi
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Link
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    Foto & Video
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.media_array" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="form.media_array.splice(index, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </template>
  
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center;" class="black--text">

                                    <div v-if="item.type !== 'video'">
                                      <v-tooltip 
                                        top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            :href="item.url"
                                            target="_blank"
                                            
                                            v-bind="attrs"
                                            v-on="on"
                                            
                                            min-width="24" min-height="24"
                                            x-small
                                            rounded
                                            :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                            elevation="0"
                                            class="white--text text-capitalize mx-1 px-0"
                                            style="font-weight: 600; border-radius: 6px;">
                                            <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                          </v-btn>
                                        </template>
    
                                        <span>Lihat</span>
                                      </v-tooltip>
                                    </div>
                                    <div v-if="item.type === 'video'">
                                      <ValidationProvider
                                        name="Link Video" 
                                        rules="required" 
                                        v-slot="{ errors, valid }">
                    
                                        <v-text-field
                                          v-on:keydown.enter.prevent="save()"
                                          
                                          filled
                                          rounded
                                          dense
                    
                                          :color="set_color"
                                          placeholder="Contoh. https://www.youtube.com/watch?v=video_id"
                    
                                          hide-details
                    
                                          v-model="item.url"
                                          :success="item.url !== '' && valid"
                                          v-on:change="item.img_url = `https://img.youtube.com/vi/${youtube_parser(item.url)}/0.jpg`"
                                          :error-messages="errors"
                                          required
                                          style="border-radius: 10px; width: 350px; min-width: 350px;">
                                          <template v-slot:append-outer>
                                            <div v-if="errors.length > 0">
                                              <v-tooltip top color="#ff5252">
                                                <template v-slot:activator="{ on }">
                                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                
                                                {{ errors[0] }}
                                              </v-tooltip>
                                            </div>
                    
                                            <div v-if="item.url !== '' && valid">
                                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                                            </div>
                                          </template>
                                        </v-text-field>
                                      </ValidationProvider>
                                    </div>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    <ValidationProvider 
                                      :name="`Nama Foto & Video ${index + 1}`" 
                                      rules="required" 
                                      v-slot="{ errors, valid }">
                  
                                      <v-text-field
                                        v-on:keydown.enter.prevent="save()"
                                        
                                        filled
                                        rounded
                                        dense
                  
                                        :color="set_color"
                                        placeholder="Nama Foto & Video"
                  
                                        hide-details
                  
                                        v-model="item.title"
                                        :success="item.title !== '' && valid"
                                        :error-messages="errors"
                                        required
                                        class="mb-0"
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                  
                                          <div v-if="item.title !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div>
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
                            </div>
  
  
                            <v-card-text
                              v-if="form.media_array.length === 0"
                              class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                              <div class="text-center">
                                <div class="mt-3 fs-16">
                                  Belum ada data
                                </div>
                              </div>
                            </v-card-text>
  
                          </v-col> 
                        </v-row>
                      </v-form>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4">
              <v-col 
                cols="12"
                md="8">
                <div v-if="message.error.length > 0"
                  class="text-left d-flex align-center">
                  <div
                    class="error--text">
                    <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col 
                cols="12"
                md="4"
                class="d-flex align-center justify-end py-0">
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  elevation="0"
                  rounded
                  color="success"
                  class="fs-16 white--text text-capitalize">
                  <v-icon
                    size="20">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
  
                  <span
                    class="ml-2">
                    Simpan
                  </span>
                </v-btn>
                
                <v-btn
                  to="/product"
                  :disabled="process.form"
                  color="red"
                  elevation="0"
                  rounded
                  class="fs-16 white--text text-capitalize d-flex align-center ml-4"
                  style="font-weight: 600;">
                  <v-icon 
                    size="20">
                    mdi-progress-close
                  </v-icon>
  
                  <span
                    class="ml-2">
                    Batal
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          unit: [],
  
          form: {
            id: '',
            name: '',
            desc: '',
            capacity_array: [],
            address: '',
            latitude: '',
            longitude: '',
            media_array: [],
            pic_name: '',
            pic_wa_number: ''
          },
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },
          markers: [],
          filename: [],
          upload: {
            image: null,
            document: null
          },
          all_document: [],
          client: [],
          location: [],
          show: false,
          upload: {
            image: null
          },
  
          process: {
            form: false,
  
            image: false,
            document: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
        uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              // this.form.request_file_object.type = 'image'
              this.message.error = ''
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                this.form.media_array.push({
                  title: '',
                  url: this.upload.image.fileuri,
                  img_url: this.upload.image.fileuri,
                  type: 'image'
                })
  
                this.upload.image = null
  
                // this.form.request_file_object.url = this.upload.image.data.full.file_url
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.form.request_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document.fileuri.match(regexp);
                // CALLBACK FROM UPLOAD IMAGE
                this.filename.push(this.upload.document.filename)
                this.form.media_array.push({
                  title: '',
                  url: this.upload.document.fileuri,
                  type: extension && extension[1]
                })
  
                this.upload.document = null
  
                // this.form.request_file_object.url = this.upload.document.data.full.file_url
              }
            }
          },
          deep: true
        },
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        outlet () {
          return this.$store.state.outlet
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          let params = {
            id: this.$route.params.id
          }
          await get(`admin/product/data`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
              
            if (res.status === 200) {
              // this.form = res.results.data
              this.form.id = res.results.data[0].id
              this.form.name = res.results.data[0].name
              this.form.desc = res.results.data[0].desc
              this.form.capacity_array = res.results.data[0].capacity_array
              this.form.address = res.results.data[0].address
              this.form.latitude = res.results.data[0].latitude
              this.form.longitude = res.results.data[0].longitude
              this.form.pic_name = res.results.data[0].pic_name
              this.form.pic_wa_number = ((res.results.data[0].pic_wa_number).toString()).replace(/^62/, '').replace(/^\+/, '').replace(/^0/, '')
              this.form.media_array = JSON.parse(res.results.data[0].media_arr)
            }
          })
        },

        youtube_parser(url){
          var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
          var match = url.match(regExp);
          return (match&&match[7].length==11)? match[7] : false;
        },
        setPlace(place) {
          this.place = place
          this.center = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          
          }
            // this.initMap()
          this.form.latitude = this.place.geometry.location.lat()
          this.form.longitude = this.place.geometry.location.lng()
        },
        getGeoLocation() {
          if (this.form.id === '') {
            navigator.geolocation.getCurrentPosition(position => {
              this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
            })
          } else {
            this.center = {
              lat: this.form.latitude,
              lng: this.form.longitude
            }
          }
        },
        updatePlace(location) {
          this.center = {
            lat: location.latLng.lat(),
            lng: location.latLng.lng()
          }
  
          this.form.latitude = location.latLng.lat()
          this.form.longitude = location.latLng.lng()
        },
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate(),
                isDocument = this.form.media_array.length > 0
          this.message.error = !isValid ? 'Silahkan lengkapi form' : !isDocument ? 'Media gedung harus diisi' : ''
          if (isValid && isDocument) {
            this.process.form = true
  
            // SAVE TO REST API
            await post(`admin/product/update`, {
              data: {
                id: this.form.id,
                name: this.form.name,
                desc: this.form.desc,
                media_array: this.form.media_array,
                capacity_array: this.form.capacity_array,
                address: this.form.address,
                latitude: this.form.latitude,
                longitude: this.form.longitude,
                pic_name: this.form.pic_name,
                pic_wa_number: `62${this.form.pic_wa_number.replace(/^0/, '')}`
              }
            })
            .then((response) => {
              let res = response.data
  
              this.process.form = false
  
              if (res.status === 200) {
  
                if (this.$route.query.form === 'list') {
                  this.$router.push('/product')
                } else {
                  this.$router.push('/product/detail/' + this.form.id)
                }
  
              } else {
                this.message.error = res.message
              }
            })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        }
      }
    }
  </script>